// MSAGL class for a Point and any Group boundary crossings at that Point, for Rectilinear Edge Routing.
export class PointAndCrossings {
    constructor(loc, crossings) {
        this.Crossings = [];
        this.Location = loc;
        this.Crossings = crossings;
    }
}
//# sourceMappingURL=PointAndCrossings.js.map